import { GsFormField } from '../../../components';
import { PictureDisplayMode } from '../../../models';

/**
 * Builds a Select form field for PictureDisplayMode with configurable formControlName, label, description and grouping.
 * @param formControlName name of the FormControl
 * @param labelKey i18n key for the label (default: schema.items.pictureDisplayMode.label)
 * @param descriptionKey i18n key for the description (default: schema.items.pictureDisplayMode.description)
 * @param groupingName optional grouping name for the form
 * @returns the GsFormField definition for PictureDisplayMode
 */
export function pictureDisplayModeSchemaFor(
  formControlName: string,
  labelKey: string = 'schema.items.pictureDisplayMode.label',
  descriptionKey: string = 'schema.items.pictureDisplayMode.description',
  groupingName?: string
): GsFormField<never> {
  return {
    formControlName,
    label: labelKey,
    description: descriptionKey,
    type: 'select',
    valueType: 'number',
    default: PictureDisplayMode.Auto,
    groupingName,
    options: [
      { text: 'schema.items.pictureDisplayMode.options.auto', value: PictureDisplayMode.Auto },
      { text: 'schema.items.pictureDisplayMode.options.cut', value: PictureDisplayMode.Cut },
      { text: 'schema.items.pictureDisplayMode.options.full', value: PictureDisplayMode.Full }
    ]
  };
}

export const PICTURE_DISPLAY_MODE_SCHEMA: GsFormField<never>[] = [pictureDisplayModeSchemaFor('pictureDisplayMode')];

export const PICTURE_DISPLAY_MODE_WITH_PHOTOS_SCHEMA: GsFormField<never>[] = [
  {
    ...PICTURE_DISPLAY_MODE_SCHEMA[0],
    if: {
      args: [{ formControlName: 'showPhotos', value: true }]
    }
  } as GsFormField<never>
];
